import React, { useRef, useEffect } from 'react';
import { HashLink as Link } from 'react-router-hash-link';
function TestimonialHome() {
    const testimonialRef = useRef(null); // Create a reference to the testimonial container

    // Function to scroll the container horizontally
    const scrollNext = () => {
        if (testimonialRef.current) {
            testimonialRef.current.scrollBy({
                left: 400, // Scroll 400px to the right (adjust as needed)
                behavior: 'smooth', // Smooth scroll animation
            });
        }
    };

    const scrollPrev = () => {
        if (testimonialRef.current) {
            testimonialRef.current.scrollBy({
                left: -400, // Scroll 400px to the left (adjust as needed)
                behavior: 'smooth', // Smooth scroll animation
            });
        }
    };

    useEffect(() => {
        const interval = setInterval(() => {
            if (testimonialRef.current) {
                const { scrollLeft, scrollWidth, clientWidth } = testimonialRef.current;
                // If we've reached the end, scroll back to the start
                if (scrollLeft + clientWidth >= scrollWidth - 10) {
                    testimonialRef.current.scrollTo({ left: 0, behavior: 'smooth' });
                } else {
                    testimonialRef.current.scrollBy({ left: 400, behavior: 'smooth' });
                }
            }
        }, 3500); // Auto-scroll every 3.5 seconds

        return () => clearInterval(interval); // Cleanup on component unmount
    }, []);

    return (
        <>

            <section className='testimonial-section' style={{ position: 'relative' }}>
                <div className="container">
                    <div className="testimonial">
                        <h1>Personal Journeys</h1>
                        <h4 className='text-center fw-bold offering-title'>
                            What healthy lifestyle seekers say about us
                        </h4>

                        <div className="all-testimonial mt-5" style={{
                            display: 'flex',
                            overflowX: 'auto',
                            scrollSnapType: 'x mandatory',
                            gap: '20px',
                        }} ref={testimonialRef}>

                            <div className="testimonial-dtail" style={{ scrollSnapAlign: 'start', flex: '0 0 33%' }}>
                                <div className="testimonial-image">
                                    <Link to="/testimonial#priyanka" smooth>
                                        <img src="images/priyanka_testimonial.jpeg" alt="" />
                                    </Link>
                                </div>
                                <div className="testimonial-text">
                                    <h5 className='fw-bold text-start mt-3'>Priyanka Bhargava</h5>
                                    <h6 className='text-start mb-4'><strong>Delivery Director, VRIZE, New Delhi
                                    </strong></h6>
                                    <p className='custom-justify'>"Embracing natural healing techniques has been a transformative journey for me. As a first hand experience, I have seen immense growth in my son's immunity."</p>
                                    <Link to="/testimonial#priyanka" smooth>
                                        <button type="button" className="btn">View Story</button>
                                    </Link>
                                </div>
                            </div>

                            <div className="testimonial-dtail" style={{ scrollSnapAlign: 'start', flex: '0 0 33%' }}>
                                <div className="testimonial-image">
                                    <Link to="/testimonial#sikha" smooth>
                                        <img src="images/sikha-jain.jpeg" alt="" />
                                    </Link>
                                </div>
                                <div className="testimonial-text">
                                    <h5 className='fw-bold text-start mt-3'>Sikha Jain</h5>
                                    <h6 className='text-start mb-4'><strong>Homemaker, Dhar</strong></h6>
                                    <p className='custom-justify'>"I have experienced a remarkable transformation in my life through this journey. I’ve successfully brought my diabetes under complete control."</p>
                                    <Link to="/testimonial#sikha" smooth>
                                        <button type="button" className="btn">View Story</button>
                                    </Link>
                                </div>
                            </div>

                            <div className="testimonial-dtail" style={{ scrollSnapAlign: 'start', flex: '0 0 33%' }}>
                                <div className="testimonial-image">
                                    <Link to="/testimonial#rajiv" smooth>
                                        <img src="images/rajiv_borar.jpeg" alt="" />
                                    </Link>
                                </div>
                                <div className="testimonial-text">
                                    <h5 className='fw-bold text-start mt-3'>Rajiv Borar</h5>
                                    <h6 className='text-start mb-4'><strong>Underwriter, Munich Re, Mumbai</strong></h6>
                                    <p className='custom-justify'>"The Anuyog Institute's resources have been incredibly impactful in helping me lead a healthier and more balanced lifestyle."</p>
                                    <Link to="/testimonial#rajiv" smooth>
                                        <button type="button" className="btn">View Story</button>
                                    </Link>
                                </div>
                            </div>

                            <div className="testimonial-dtail" style={{ scrollSnapAlign: 'start', flex: '0 0 33%' }}>
                                <div className="testimonial-image">
                                    <Link to="/testimonial#aashish" smooth>
                                        <img src="images/aashish.jpeg" alt="" />
                                    </Link>
                                </div>
                                <div className="testimonial-text">
                                    <h5 className='fw-bold text-start mt-3'>Ashish Sharma</h5>
                                    <h6 className='text-start mb-4'><strong>Data Scientist, Swiss Re, Bangalore</strong></h6>
                                    <p className='custom-justify'>"Adopting a natural lifestyle with Anuyog, I've felt so much better. In a world full of chemicals and processed products, I'm thankful"</p>
                                    <Link to="/testimonial#aashish" smooth>
                                        <button type="button" className="btn">View Story</button>
                                    </Link>
                                </div>
                            </div>

                            <div className="testimonial-dtail" style={{ scrollSnapAlign: 'start', flex: '0 0 33%' }}>
                                <div className="testimonial-image">
                                    <Link to="/testimonial#mohsin" smooth>
                                        <img src="images/mohsin.jpeg" alt="" />
                                    </Link>
                                </div>
                                <div className="testimonial-text">
                                    <h5 className='fw-bold text-start mt-3'>Mohsin</h5>
                                    <h6 className='text-start mb-4'><strong>Sr. CSA Teleperformance,Mumbai</strong></h6>
                                    <p className='custom-justify'>"With the help of Anuyog, I am now more well versed with different ways of leading a healthy lifestyle and also the combination of foods that are good."</p>
                                    <Link to="/testimonial#mohsin" smooth>
                                        <button type="button" className="btn">View Story</button>
                                    </Link>
                                </div>
                            </div>

                            <div className="testimonial-dtail" style={{ scrollSnapAlign: 'start', flex: '0 0 33%' }}>
                                <div className="testimonial-image">
                                    <Link to="/testimonial#rahul" smooth>
                                        <img src="images/rahul.jpeg" alt="" />
                                    </Link>
                                </div>
                                <div className="testimonial-text">
                                    <h5 className='fw-bold text-start mt-3'>Rahul Sharma</h5>
                                    <h6 className='text-start mb-4'><strong>Founder, Gayatri Sublimation Prints, Prayagraj</strong></h6>
                                    <p className='custom-justify'>"Anuyog has played a significant role in transforming my life, enhancing my physical, mental, and emotional."</p>
                                    <Link to="/testimonial#rahul" smooth>
                                        <button type="button" className="btn">View Story</button>
                                    </Link>
                                </div>
                            </div>





                        </div>
                    </div>
                    <div className="how home">
                        <Link onClick={() => {
                            window.scrollTo(0, 0);
                        }} to="/testimonial" smooth>
                            <button type="button" className="btn mt-4 mb-3">View All Testimonial</button>
                        </Link>
                    </div>
                </div>

                <button onClick={scrollPrev} className="arrow-btn left-arrow">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-arrow-left" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8" />
                    </svg>

                </button>
                <button onClick={scrollNext} className="arrow-btn right-arrow">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                    </svg>

                </button>
            </section>

        </>
    )
}

export default TestimonialHome
